// The notifications list, polled once for the whole app (sharedPoll.js): the bell and the pop-ups both read it.
import { createPoller } from '../hooks/sharedPoll';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';
const POLL_MS = 30000;

export const notificationsFeed = createPoller(() => {
  const token = localStorage.getItem('token');
  if (!token) return undefined;
  return fetch(`${API_BASE}/api/notifications`, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => (r.ok ? r.json() : undefined))
    .then((d) => (Array.isArray(d) ? d : undefined));
}, POLL_MS);
